import type { ReactNode } from 'react';

export const symbol_phone_cancel: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M795-120q-116 0-236.5-56T335-335Q232-438 176-558.5T120-795q0-19.29 12.86-32.14Q145.71-840 165-840h140q13.61 0 24.31 10Q340-820 343-805l26.93 125.64Q372-665 369.5-653.5t-10.73 19.73L259-533q26 44 55.5 81.5T378-379q38 38 78.5 69.5T542-254l95-98q10-11 23-15.5t26-1.5l119 26q15.31 3.36 25.16 15.68Q840-315 840-300v135q0 19.29-12.86 32.14Q814.29-120 795-120ZM229-588l81-82-23-110H180q2 42 13.5 88.5T229-588Zm369 363q41 19 89 31t93 14v-107l-103-21-79 83ZM229-588Zm369 363Zm117-447-63 62q-9 8-21.1 8.5-12.1.5-20.9-8.5-9-9-8.5-21t8.5-21l62-63-62-62q-9-9-9-21.16t8.61-21Q619-828 631-827.5t21 8.5l63 62 62-62q9-9 21.16-9t21 8.84q8.84 8.84 8.84 21T819-777l-62 62 62 63q8 9 8.5 21t-8.5 21.39q-9 8.61-21 8.61t-21-9l-62-62Z"
		/>
	</svg>
);
